import React from 'react';
import { DATE_DISPLAYED_REGION, DATE_DISPLAYED_TIMEZONE } from '../../../resources/constants/ui';

import chevronDown from "../../../resources/media/chevron-down.svg";
import { Form, Col, Row, Button } from "react-bootstrap";

import {
	DOCKET_PREFIXES,
	DOCKET_SUFFIXES,
	GENERAL_FILING_TYPES,
	DECIDING_BODIES,
	DECISION_TYPES,
	RECORDATION_CATEGORIES
} from "../../../resources/constants/dropdowns";
import {
	SEARCH_FOR_OPTIONS
} from "../../../resources/constants/searches";
import {
	DOCKET_NUM_PART_ONE_NAME,
	DOCKET_NUM_PART_TWO_NAME,
	DOCKET_NUM_PART_THREE_NAME,
	DOCKET_NUM_PART_FOUR_NAME,
	DOCKET_TITLE_LABEL,
	DOCKET_TITLE_NAME,
	SERVICE_DATE_LABEL,
	SERVICE_DATE_START_LABEL,
	SERVICE_DATE_START_NAME,
	SERVICE_DATE_END_LABEL,
	SERVICE_DATE_END_NAME,
	OFFICIAL_FILING_DATE_START_NAME,
	OFFICIAL_FILING_DATE_END_NAME,
	DECISION_TYPE_LABEL,
	DECISION_TYPE_NAME,
	DECISION_ID_LABEL,
	DECISION_ID_NAME,
	DECIDING_BODY_LABEL,
	DECIDING_BODY_NAME,
	DECISION_SUMMARY_LABEL,
	DECISION_SUMMARY_NAME,
	FILING_DATE_START_LABEL,
	FILING_DATE_START_NAME,
	FILING_DATE_END_LABEL,
	FILING_DATE_END_NAME,
	FILING_TYPE_LABEL,
	FILING_TYPE_NAME,
	FILED_FOR_LABEL,
	FILED_FOR_NAME,
	FILING_ID_LABEL,
	FILING_ID_NAME,
	RECORDATION_CATEGORY_LABEL,
	RECORDATION_CATEGORY_FIELD,
	RECORDATION_NO_LABEL,
	RECORDATION_SUFFIX_LABEL,
	RECORDATION_SUFFIX_NAME,
	RECORDATION_PARTY_LABEL,
	RECORDATION_PARTY_NAME,
	RECORDATION_TYPE_OF_AGREEMENT_LABEL,
	RECORDATION_TYPE_OF_AGREEMENT_NAME,
	RECORDATION_EQUIPMENT_DESCRIPTION_LABEL,
	RECORDATION_EQUIPMENT_DESCRIPTION_NAME,
	DATE_TO_VIEW_LABEL,
	DATE_TO_VIEW_NAME,
	SEARCH_FOR_LABEL,
	SEARCH_FOR_NAME,
	DOCKET_NUM_LABEL,
	DOCUMENT_TEXT_SEARCH_LABEL,
	DOCUMENT_TEXT_SEARCH_ALL_LABEL,
	DOCUMENT_TEXT_SEARCH_ALL_NAME,
	DOCUMENT_TEXT_SEARCH_EXACT_LABEL,
	DOCUMENT_TEXT_SEARCH_EXACT_NAME,
	DOCUMENT_TEXT_SEARCH_ANY_LABEL,
	DOCUMENT_TEXT_SEARCH_ANY_NAME,
	DOCUMENT_TEXT_SEARCH_NONE_LABEL,
	DOCUMENT_TEXT_SEARCH_NONE_NAME,
	OFFICIAL_FILING_DATE_LABEL,
	RECORDATION_NUM_FIELD,
	ENVCOM_ORGANIZATION_FORM_LABEL,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_SUBMITTER_OR_RECIPIENT_LABEL,
	ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD,
	ENVCOM_DATE_RANGE_LABEL,
	ENVCOM_DATE_START_LABEL,
	ENVCOM_DATE_START_NAME,
	ENVCOM_DATE_END_LABEL,
	ENVCOM_DATE_END_NAME,
	ENVCOM_ID_FIELD,
	ENVCOM_TYPE_ID_FIELD,
	ENVCOM_ID_LABEL
} from "../../../resources/constants/fields";
import { INVALID_ICON, INVALID_NUMBER_ERROR } from "../../../resources/constants/errors";
import {
	ACTIVE_CLASS_NAME,
	CLICK_TO_COLLAPSE_TEXT,
	CLICK_TO_EXPAND_TEXT
} from "../../../resources/constants/ui";
import {RemoveIcon} from "../../../resources/media/RemoveIcon";
import { isNumber } from "../../Form/util/validation";

import { DATE_PLACEHOLDER } from "../../../resources/constants/validations";


//FIELD COMPONENTS
export class SearchDropdownField extends React.Component {
	render() {
		return (
			<Form.Control
				disabled={this.props.disabled}
				as="select"
				name={this.props.name}
				value={this.props.value}
				onChange={this.props.handleChange}
			>
				{this.props.options}
			</Form.Control>
		);
	}
}

export class SearchTextField extends React.Component {
	render() {
		return (
			<React.Fragment>
				<Form.Control
					name={this.props.name}
					className="invalid-padding"
					defaultValue={this.props.value}
					onChange={this.props.handleChange}
					isInvalid={this.props.number ? !isNumber(this.props.value) : false}
				/>
				<Form.Control.Feedback type="invalid" className="invalid-box">
					{INVALID_ICON(INVALID_NUMBER_ERROR)}
				</Form.Control.Feedback>
			</React.Fragment>
		);
	}
}

export class SearchDateField extends React.Component {
	constructor(props) {
		super(props);
		this.clearValue = this.clearValue.bind(this);
	}
	clearValue() {
		document.getElementsByName(this.props.name)[0].value = "";
	}
	render() {
		return (
			<SplitFormCol label={this.props.label} labelSize={this.props.labelSize}>
				<Row className="date-row">
					<Col>
				<Form.Control
					type="date"
					name={this.props.name}
					value={this.props.value || ""}
					onChange={this.props.handleChange}
					placeholder={DATE_PLACEHOLDER}
					className={``}
				/>
				</Col>
				{typeof InstallTrigger === 'undefined' ? <Button
					className="clear_date__btn"
					variant="link"
					onClick={() => {
						this.props.clearFieldsByName([this.props.name]);
						this.clearValue();
					}}
				>
					<RemoveIcon />
				</Button> : null}
				</Row>
			</SplitFormCol>
		);
	}
}

export class SearchForField extends React.Component {
	render() {
		return (
			<React.Fragment>
				<WideFormCol label={<h5>{SEARCH_FOR_LABEL}</h5>}>
					<SearchDropdownField
						name={SEARCH_FOR_NAME}
						value={this.props.searchFor}
						handleChange={this.props.handleChange}
						options={SEARCH_FOR_OPTIONS.map(searchForOption => {
							return (
								<option key={searchForOption}>
									{searchForOption}
								</option>
							);
						})}
					/>
				</WideFormCol>
			</React.Fragment>
		);
	}
}

export class DocumentSearchField extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded:
				props.fields[DOCUMENT_TEXT_SEARCH_ALL_NAME] ||
				props.fields[DOCUMENT_TEXT_SEARCH_ANY_NAME] ||
				props.fields[DOCUMENT_TEXT_SEARCH_EXACT_NAME] ||
				props.fields[DOCUMENT_TEXT_SEARCH_NONE_NAME]
		};
		this.expandSearch = this.expandSearch.bind(this);
	}

	expandSearch() {
		if (this.state.expanded) {
			this.setState({ expanded: false });
		} else {
			this.setState({ expanded: true });
		}
	}

	render() {
		var active = this.state.expanded ? ACTIVE_CLASS_NAME : "";
		var titleText = this.state.expanded
			? CLICK_TO_COLLAPSE_TEXT
			: CLICK_TO_EXPAND_TEXT;
		return (
			<>
				<div className="center document-text-search">
					<Button
						variant="link"
						onClick={this.expandSearch}
						title={titleText}
					>
						{DOCUMENT_TEXT_SEARCH_LABEL}
						<img
							src={chevronDown}
							alt={DOCUMENT_TEXT_SEARCH_LABEL}
							className={`document-text-search__chevron ${active}`}
						/>
					</Button>
				</div>
				{this.state.expanded ? (
					<React.Fragment>
						<AllOfTheseWordsField
							fields={this.props.fields}
							handleChange={this.props.handleChange}
						/>
						<ExactPhraseField
							fields={this.props.fields}
							handleChange={this.props.handleChange}
						/>
						<AnyOfTheseWordsField
							fields={this.props.fields}
							handleChange={this.props.handleChange}
						/>
						<NoneOfTheseWordsField
							fields={this.props.fields}
							handleChange={this.props.handleChange}
						/>
					</React.Fragment>
				) : null}
			</>
		);
	}
}

export class AllOfTheseWordsField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DOCUMENT_TEXT_SEARCH_ALL_LABEL} labelSize={2}>
				<SearchTextField
					name={DOCUMENT_TEXT_SEARCH_ALL_NAME}
					value={this.props.fields[DOCUMENT_TEXT_SEARCH_ALL_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class ExactPhraseField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DOCUMENT_TEXT_SEARCH_EXACT_LABEL} labelSize={2}>
				<SearchTextField
					name={DOCUMENT_TEXT_SEARCH_EXACT_NAME}
					value={this.props.fields[DOCUMENT_TEXT_SEARCH_EXACT_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class AnyOfTheseWordsField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DOCUMENT_TEXT_SEARCH_ANY_LABEL} labelSize={2}>
				<SearchTextField
					name={DOCUMENT_TEXT_SEARCH_ANY_NAME}
					value={this.props.fields[DOCUMENT_TEXT_SEARCH_ANY_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class NoneOfTheseWordsField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DOCUMENT_TEXT_SEARCH_NONE_LABEL} labelSize={2}>
				<SearchTextField
					name={DOCUMENT_TEXT_SEARCH_NONE_NAME}
					value={this.props.fields[DOCUMENT_TEXT_SEARCH_NONE_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class DocketNumField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DOCKET_NUM_LABEL}>
				<Row>
					<Col sm={3}>
						<Form.Control
							as="select"
							name={DOCKET_NUM_PART_ONE_NAME}
							className="right-corners--sharp"
							value={this.props.fields[DOCKET_NUM_PART_ONE_NAME]}
							onChange={this.props.handleChange}
						>
							{[
								<option key="" />,
								...DOCKET_PREFIXES.map((prefix, idx) => {
									return (
										<option key={`${idx}-${prefix}`}>
											{prefix}
										</option>
									);
								})
							]}
						</Form.Control>
					</Col>

					<Col sm={3}>
						<Form.Control
							type="text"
							name={DOCKET_NUM_PART_TWO_NAME}
							className="invalid-padding no-border-radius"
							defaultValue={
								this.props.fields[DOCKET_NUM_PART_TWO_NAME]
							}
							onChange={this.props.handleChange}
							isInvalid={!isNumber(this.props.fields[DOCKET_NUM_PART_TWO_NAME])}
						/>
						<Form.Control.Feedback type="invalid" className="invalid-box">
							{INVALID_ICON(INVALID_NUMBER_ERROR)}
						</Form.Control.Feedback>
					</Col>

					<Col sm={3}>
						<Form.Control
							type="text"
							name={DOCKET_NUM_PART_THREE_NAME}
							className="invalid-padding no-border-radius"
							defaultValue={
								this.props.fields[DOCKET_NUM_PART_THREE_NAME]
							}
							onChange={this.props.handleChange}
							isInvalid={!isNumber(this.props.fields[DOCKET_NUM_PART_THREE_NAME])}
						/>
						<Form.Control.Feedback type="invalid" className="invalid-box">
							{INVALID_ICON(INVALID_NUMBER_ERROR)}
						</Form.Control.Feedback>
					</Col>

					<Col sm={3}>
						<Form.Control
							as="select"
							name={DOCKET_NUM_PART_FOUR_NAME}
							className="left-corners--sharp"
							value={this.props.fields[DOCKET_NUM_PART_FOUR_NAME]}
							onChange={this.props.handleChange}
						>
							{[
								...DOCKET_SUFFIXES.map((suffix, idx) => {
									return (
										<option key={`${idx}-${suffix}`}>
											{suffix}
										</option>
									);
								})
							]}
						</Form.Control>
					</Col>
				</Row>
			</SplitFormCol>
		);
	}
}

export class DocketTitleField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DOCKET_TITLE_LABEL}>
				<SearchTextField
					name={DOCKET_TITLE_NAME}
					value={this.props.fields[DOCKET_TITLE_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class DateRangeField extends React.Component {
	render() {
		return (
			<DynamicFormRow className={"date-range"}>
				<Form.Label 
					className="vert-center pad-left" 
					size={2}
				>
					{this.props.dateRangeLabel}
				</Form.Label>
				<SearchDateField
					size={4}
					label={this.props.dateRangeStartLabel}
					labelSize={3}
					name={this.props.dateRangeStartName}
					value={this.props.fields[this.props.dateRangeStartName]}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
				<SearchDateField
					size={6}
					label={this.props.dateRangeEndLabel}
					labelSize={4}
					name={this.props.dateRangeEndName}
					value={this.props.fields[this.props.dateRangeEndName]}
					handleChange={this.props.handleChange}
					clearFieldsByName={this.props.clearFieldsByName}
				/>
			</DynamicFormRow>
		);
	}
}

export class ServiceDateRangeField extends React.Component {
	render() {
		return (
			<DateRangeField
				dateRangeLabel={SERVICE_DATE_LABEL}
				dateRangeStartLabel={SERVICE_DATE_START_LABEL}
				dateRangeStartName={SERVICE_DATE_START_NAME}
				dateRangeEndLabel={SERVICE_DATE_END_LABEL}
				dateRangeEndName={SERVICE_DATE_END_NAME}
				fields={this.props.fields}
				handleChange={this.props.handleChange}
				clearFieldsByName={this.props.clearFieldsByName}
			/>
		);
	}
}

export class RecordationFilingDateRangeField extends React.Component {
	render() {
		return (
			<DateRangeField
				dateRangeLabel={OFFICIAL_FILING_DATE_LABEL}
				dateRangeStartLabel={FILING_DATE_START_LABEL}
				dateRangeStartName={OFFICIAL_FILING_DATE_START_NAME}
				dateRangeEndLabel={FILING_DATE_END_LABEL}
				dateRangeEndName={OFFICIAL_FILING_DATE_END_NAME}
				fields={this.props.fields}
				handleChange={this.props.handleChange}
				clearFieldsByName={this.props.clearFieldsByName}
			/>
		);
	}
}

export class DecisionTypeField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DECISION_TYPE_LABEL}>
				<SearchDropdownField
					label={DECISION_TYPE_LABEL}
					name={DECISION_TYPE_NAME}
					value={this.props.fields[DECISION_TYPE_NAME]}
					handleChange={this.props.handleChange}
					options={[
						<option key="" />,
						...DECISION_TYPES.map((decision_type, idx) => {
							return (
								<option key={`${idx}-${decision_type}`}>
									{decision_type}
								</option>
							);
						})
					]}
				/>
			</SplitFormCol>
		);
	}
}

export class DecisionIdField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DECISION_ID_LABEL}>
				<SearchTextField
					number
					name={DECISION_ID_NAME}
					value={this.props.fields[DECISION_ID_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class DecidingBodyField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DECIDING_BODY_LABEL}>
				<SearchDropdownField
					name={DECIDING_BODY_NAME}
					value={this.props.fields[DECIDING_BODY_NAME]}
					handleChange={this.props.handleChange}
					options={[
						<option key="" />,
						...DECIDING_BODIES.map((deciding_body, idx) => {
							return (
								<option key={`${idx}-${deciding_body}`}>
									{deciding_body}
								</option>
							);
						})
					]}
				/>
			</SplitFormCol>
		);
	}
}

export class SummaryField extends React.Component {
	render() {
		return (
			<SplitFormCol label={DECISION_SUMMARY_LABEL}>
				<SearchTextField
					name={DECISION_SUMMARY_NAME}
					value={this.props.fields[DECISION_SUMMARY_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class FilingDateRangeField extends React.Component {
	render() {
		return (
			<DateRangeField
				dateRangeLabel={OFFICIAL_FILING_DATE_LABEL}
				dateRangeStartLabel={FILING_DATE_START_LABEL}
				dateRangeStartName={FILING_DATE_START_NAME}
				dateRangeEndLabel={FILING_DATE_END_LABEL}
				dateRangeEndName={FILING_DATE_END_NAME}
				fields={this.props.fields}
				handleChange={this.props.handleChange}
				clearFieldsByName={this.props.clearFieldsByName}
			/>
		);
	}
}

export class FilingTypeField extends React.Component {
	render() {
		return (
			<WideFormCol label={FILING_TYPE_LABEL}>
				<SearchDropdownField
					name={FILING_TYPE_NAME}
					value={this.props.fields[FILING_TYPE_NAME]}
					handleChange={this.props.handleChange}
					options={[
						<option key="" />,
						...GENERAL_FILING_TYPES.map((filing_type, idx) => {
							return (
								<option key={`${idx}-${filing_type}`}>
									{filing_type}
								</option>
							);
						})
					]}
				/>
			</WideFormCol>
		);
	}
}

export class FiledForField extends React.Component {
	render() {
		return (
			<SplitFormCol label={FILED_FOR_LABEL}>
				<SearchTextField
					name={FILED_FOR_NAME}
					value={this.props.fields[FILED_FOR_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class FilingIdField extends React.Component {
	render() {
		return (
			<SplitFormCol label={FILING_ID_LABEL}>
				<SearchTextField
					number
					name={FILING_ID_NAME}
					value={this.props.fields[FILING_ID_NAME]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class RecordationCategoryField extends React.Component {
	render() {
		return (
			<SplitFormCol label={RECORDATION_CATEGORY_LABEL} labelSize={6}>
				<SearchDropdownField // Make this a radio field
					label={RECORDATION_CATEGORY_LABEL}
					name={RECORDATION_CATEGORY_FIELD}
					value={this.props.fields[RECORDATION_CATEGORY_FIELD]}
					handleChange={this.props.handleChange}
					options={RECORDATION_CATEGORIES.map((category, idx) => {
						return (
							<option key={`${idx}-${category}`}>{category}</option>
						);
					})}
				/>
			</SplitFormCol>
		);
	}
}

export class RecordationNumberField extends React.Component {
	render() {
		return (
			<SplitFormCol label={RECORDATION_NO_LABEL} labelSize={this.props.labelSize}>
				<SearchTextField
					label={RECORDATION_NO_LABEL}
					name={RECORDATION_NUM_FIELD}
					value={this.props.fields[RECORDATION_NUM_FIELD]}
					handleChange={this.props.handleChange}
				/>
			</SplitFormCol>
		);
	}
}

export class RecordationSuffixField extends React.Component {
	render() {
		return (
			<DynamicFormRow className={"form-group"}>
				<Form.Label 
					size={6}
					className="vert-center pad-left" 
				>
					{RECORDATION_SUFFIX_LABEL}
				</Form.Label>
				<SearchTextField
					size={6}
					label={RECORDATION_SUFFIX_LABEL}
					name={RECORDATION_SUFFIX_NAME}
					value={this.props.fields[RECORDATION_SUFFIX_NAME]}
					handleChange={this.props.handleChange}
				/>
			</DynamicFormRow>
		);
	}
}

export class RecordationPartyField extends React.Component {
	render() {
		return (
			<DynamicFormRow className={"form-group"}>
				<Form.Label 
					size={3}
					className="vert-center pad-left" 
				>
					{RECORDATION_PARTY_LABEL}
				</Form.Label>
				<SearchTextField
					size={9}
					label={RECORDATION_PARTY_LABEL}
					name={RECORDATION_PARTY_NAME}
					value={this.props.fields[RECORDATION_PARTY_NAME]}
					handleChange={this.props.handleChange}
				/>
			</DynamicFormRow>
		);
	}
}

export class RecordationTypeOfAgreementField extends React.Component {
	render() {
		return (
			<DynamicFormRow className={"form-group"}>
				<Form.Label 
					size={3}
					className="vert-center pad-left" 
				>
					{RECORDATION_TYPE_OF_AGREEMENT_LABEL}
				</Form.Label>
				<SearchTextField
					size={9}
					label={RECORDATION_TYPE_OF_AGREEMENT_LABEL}
					name={RECORDATION_TYPE_OF_AGREEMENT_NAME}
					value={
						this.props.fields[RECORDATION_TYPE_OF_AGREEMENT_NAME]
					}
					handleChange={this.props.handleChange}
				/>
			</DynamicFormRow>
		);
	}
}

export class RecordationEquipmentDescriptionField extends React.Component {
	render() {
		return (
			<DynamicFormRow className={"form-group"}>
				<Form.Label 
					size={3}
					className="vert-center pad-left" 
				>
					{RECORDATION_EQUIPMENT_DESCRIPTION_LABEL}
				</Form.Label>
				<SearchTextField
					size={9}
					label={RECORDATION_EQUIPMENT_DESCRIPTION_LABEL}
					name={RECORDATION_EQUIPMENT_DESCRIPTION_NAME}
					value={
						this.props.fields[RECORDATION_EQUIPMENT_DESCRIPTION_NAME]
					}
					handleChange={this.props.handleChange}
				/>
			</DynamicFormRow>
		);
	}
}

export class EnvCommentIdField extends React.Component {
	render() {
		let envComTypeId = Number(this.props.fields[ENVCOM_TYPE_ID_FIELD]);
		let labelText = (envComTypeId && envComTypeId === -1 ? "EI/EO-" : envComTypeId && envComTypeId === 18 ? "EI-" : envComTypeId && envComTypeId === 19 ? "EO-" : "");
		//{label: "All", value: -1}, {label: "Incoming", value: 18}, {label: "Outgoing", value: 19}
		return (
			<SplitFormCol label={ENVCOM_ID_LABEL} labelSize={this.props.labelSize}>
				<Row>
					<Col sm={3}>
						<Form.Label className="vert-center pad-left">{labelText}</Form.Label>
					</Col>
					<Col sm={9}>
						<Form.Control
							type="text"
							name={ENVCOM_ID_FIELD}
							className="invalid-padding no-border-radius"
							defaultValue={this.props.fields[ENVCOM_ID_FIELD]}
							onChange={this.props.handleChange}
							isInvalid={!isNumber(this.props.fields[ENVCOM_ID_FIELD])}
						/>
						<Form.Control.Feedback type="invalid" className="invalid-box">
							{INVALID_ICON(INVALID_NUMBER_ERROR)}
						</Form.Control.Feedback>
					</Col>
				</Row>
			</SplitFormCol>
		);
	}
}

export class EnvCommentsDateRangeField extends React.Component {
	render() {
		return (
			<DateRangeField
				dateRangeLabel={ENVCOM_DATE_RANGE_LABEL}
				dateRangeStartLabel={ENVCOM_DATE_START_LABEL}
				dateRangeStartName={ENVCOM_DATE_START_NAME}
				dateRangeEndLabel={ENVCOM_DATE_END_LABEL}
				dateRangeEndName={ENVCOM_DATE_END_NAME}
				fields={this.props.fields}
				handleChange={this.props.handleChange}
				clearFieldsByName={this.props.clearFieldsByName}
			/>
		);
	}
}

export class OrganizationField extends React.Component {
	render() {
		return (
			<WideFormCol label={ENVCOM_ORGANIZATION_FORM_LABEL}>
				<SearchTextField
					name={ENVCOM_ORGANIZATION_FIELD}
					value={this.props.fields[ENVCOM_ORGANIZATION_FIELD]}
					handleChange={this.props.handleChange}
				/>
			</WideFormCol>
		);
	}
}

export class SubmitterRecipientField extends React.Component {
	render() {
		return (
			<WideFormCol label={ENVCOM_SUBMITTER_OR_RECIPIENT_LABEL}>
				<SearchTextField
					name={ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD}
					value={this.props.fields[ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD]}
					handleChange={this.props.handleChange}
				/>
			</WideFormCol>
		);
	}
}

export class DateToViewField extends React.Component {
	constructor(props) {
		super(props);
		this.clearValue = this.clearValue.bind(this);
	}
	clearValue() {
		document.getElementsByName(DATE_TO_VIEW_NAME)[0].value = "";
	}
	render() {
		return (
			<WideFormCol label={DATE_TO_VIEW_LABEL}>
				<Row className="date-row">
					<Col>
					
					<Form.Control
					type="date"
					name={DATE_TO_VIEW_NAME}
					defaultValue={this.props.fields[DATE_TO_VIEW_NAME] || ""}
					onChange={this.props.handleChange}
					placeholder={DATE_PLACEHOLDER}
					className="vert-center"
				/>
				</Col>
				{typeof InstallTrigger === 'undefined' ? <React.Fragment><Button
					className="clear_date__btn"
					variant="link"
					onClick={() => {
						this.props.clearFieldsByName([DATE_TO_VIEW_NAME]);
						this.clearValue();
					}}
				>
					<RemoveIcon />
				</Button></React.Fragment> : null}
				</Row>
			</WideFormCol>
		);
	}
}

//FORMAT COMPONENTS
export function SplitFormRow(props) {
	if (props.isVisible === undefined || props.isVisible === true) {
		return (
			<Row className={props.className}>
				<Col md={6}>{props.children[0]}</Col>
				<Col md={6}>{props.children[1]}</Col>
			</Row>
		);
	}
	return null;
}

export function DynamicFormRow(props) {
	if (props.isVisible === undefined || props.isVisible === true) {
		return (
			<Row className={props.className}>
				{props.children.map((child, index) => {
					return <Col key={index} md={props.children[index].props.size}>{props.children[index]}</Col>;
				})}
			</Row>
		);
	}
	return null;
}

export function SplitFormCol(props) {
	return (
		<Row className={"form-group"}>
			<Col md={props.labelSize || 4}>
				<Form.Label className="vert-center pad-left">
					{props.label}
				</Form.Label>
			</Col>
			<Col md={props.labelSize ? 12 - props.labelSize : 8}>{props.children}</Col>
		</Row>
	);
}

export function WideFormCol(props) {
	return (
		<Row className={"form-group"}>
			<Col md={2}>
				<Form.Label className="vert-center pad-left">
					{props.label}
				</Form.Label>
			</Col>
			<Col md={10}>{props.children}</Col>
		</Row>
	);
}

export function dateObjectToISOString(dateObj){
	var dateISOString = "";
	if(dateObj && typeof dateObj === "object"){
		dateISOString = [
			dateObj.getFullYear(),
			dateObj.getMonth() + 1,
			dateObj.getDay()
		].join("-");
	}
	return dateISOString;
}

export function getPlainDate(date) {
	var localDate = date;
	const MIN_DATE_ARRAY_LENGTH = 3;
	const UTC_HOUR_MIDDAY = 12;
	let utcDay, utcMonth, utcYear, utcArray, utcDateObj;

	if (date) {
		utcArray = date.split(" ")[0].split("-");
		if (utcArray.length >= MIN_DATE_ARRAY_LENGTH) {
			utcYear = utcArray[0];
			utcMonth = utcArray[1] - 1;
			utcDay = utcArray[2];
			utcDateObj = new Date(
				Date.UTC(utcYear, utcMonth, utcDay, UTC_HOUR_MIDDAY, 0, 0)
			);
			let isDate = !isNaN(utcDateObj.valueOf());
			if (isDate) {
				localDate = utcDateObj
					.toLocaleString(DATE_DISPLAYED_REGION, {
						timezone: DATE_DISPLAYED_TIMEZONE
					})
					.split(",")[0];
			}
		}
	}

	return localDate;
}

export const getIsLateClass = (isLate) => {
	return isLate === true || isLate === "true" ? " red-text" : "";
}
